import mapboxgl from "mapbox-gl";
import {getUberLinePrimitiveLayer} from "./layers/uberLinePrimitiveLayer.js";
import {PositionParser} from "./utils/positionParser.js";
import {linePrimitiveLayer} from "./layers/linePrimitiveLayer.js";
import {pointPrimitiveLayer} from "./layers/pointPrimitiveLayer.js";
import {threeGeomLayer} from "./layers/threeGeomLayer.js";
import {threeLineLayer} from "./layers/threeLineLayer.js";
import blankLayer from "./layers/blankLayer.js";
import {fixedThreeGeomLayer} from "./layers/fixedThreeGeomLayer.js";
import {texturePointLayer} from "./layers/texturePointLayer.js";

mapboxgl.accessToken = 'pk.eyJ1IjoiZ2NkYW4iLCJhIjoiY2x2dzd3cW03MW5xMjJrbnl0b3c5aXUzNCJ9.CIsWf44jGBAXXyIOkzsDDw';

// const anchor = [-61.7964, 17.0608];
const anchor = [-5, 51];

const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/light-v11',
    zoom: 8,
    center: anchor,
    pitch: 50,
    antialias: true,
    terrain: false,
    // projection: "mercator"
});

let selectedLayer = 0;

let start = 1690030000;
let end = 1690030000;

const all = [];
const data = [];
let holder = {};
let setup = false;

let layersShowing = true;

const layers = [linePrimitiveLayer, threeGeomLayer, texturePointLayer, fixedThreeGeomLayer, pointPrimitiveLayer, threeLineLayer];
// const layers = [];

PositionParser.requestAll("cf.yb.tl", "vg24_bhjqifayfd").then(resp => {


    for (let t = 0; t < resp.length; t++) {
        let prev;
        const team = resp[t];
        const poz = team.moments;

        for (let m = 0; m < poz.length; m++) {
            const moment = poz[m];
            const record = {team: team.id, at: moment.at, lat: moment.lat, lon: moment.lon};

            if (prev) {
                prev.next = record;
            }

            prev = record;

            all.push(record);
        }

        holder[team.id] = {r: Math.random(), g: Math.random(), b: Math.random()};
    }

    resp.length = 0;

    //Sort by start and end segment
    // all.sort((a, b) => {
    //     return (a.next ? a.next.at : 0) - (b.next ? b.next.at : 0);
    // })
    all.sort((a, b) => a.at - b.at)
      .forEach(record => {
        data.push(record, record.next ? record.next : record);
    });

    all.length = 0;

    setup = true;
    const uberLinePrimitiveLayer = getUberLinePrimitiveLayer(data, holder, setup);
    layers.push(uberLinePrimitiveLayer);

    end = data[data.length - 1].at;


    start = data[0].at;
    end = data[data.length - 1].at;


    window.x = data[0].at;


    document.getElementById("control-slider").setAttribute('max', Math.floor(end).toString());
    document.getElementById("control-slider").setAttribute('min', Math.floor(start).toString());
});


document.getElementById("switch-layer").addEventListener("click", () => {
    layersShowing = true;
    const currentLayer = layers[selectedLayer];

    if (map.getLayer(currentLayer.id)) {
        map.setLayoutProperty(currentLayer.id, 'visibility', 'none');
    }

    selectedLayer = (selectedLayer + 1) % layers.length;
    const newLayer = layers[selectedLayer];


    if (!map.getLayer(newLayer.id)) {
        map.addLayer(newLayer);
    } else {
        map.setLayoutProperty(newLayer.id, 'visibility', 'visible');
    }

    console.log(`Switched to layer: ${newLayer.id}`);

    document.getElementById("current-layer-label").innerHTML = newLayer.id;


    //show slider
    if (layers[selectedLayer].id === "uber-line-primitive-layer") {
        document.getElementById("control-slider").style.display = "block";
    } else {
        document.getElementById("control-slider").style.display = "none";
    }
});

document.getElementById("toggle-layers").addEventListener("click", () => {
    const currentLayer = layers[selectedLayer];

    if (layersShowing) {
        if (map.getLayer(currentLayer.id)) {
            map.setLayoutProperty(currentLayer.id, 'visibility', 'none');
        }

        if (!map.getLayer("blank-layer")) {
            map.addLayer(blankLayer);
        } else {
            map.setLayoutProperty("blank-layer", 'visibility', 'visible');
        }
        layersShowing = false;
    } else {
        if (map.getLayer(currentLayer.id)) {
            map.setLayoutProperty(currentLayer.id, 'visibility', 'visible');
        }
        if (map.getLayer("blank-layer")) {
            map.setLayoutProperty("blank-layer", 'visibility', 'none');
        }
        layersShowing = true;
    }

    document.getElementById("current-layer-label").innerHTML = "";
});

const handleSliderChange = (e) => {

    requestAnimationFrame(() => {

        window.x = e.target.value;
        map.triggerRepaint();

    });

}

document.getElementById("control-slider").addEventListener(
  'input',
  handleSliderChange.bind(this),
);
document.getElementById("control-slider").addEventListener(
  'change',
  handleSliderChange.bind(this),
);


map.on('style.load', () => {

    for (const layer of map.getStyle().layers) {

        if (layer.type !== 'symbol') {

            // map.setLayoutProperty(layer.id, 'visibility', 'none');

        }

    }

    map.addLayer(layers[selectedLayer]);
    document.getElementById("current-layer-label").innerHTML = layers[selectedLayer].id;

    map.addSource('point', {
        'type': 'geojson', 'data': {
            'type': 'FeatureCollection', 'features': [{
                'type': 'Feature', 'geometry': {
                    'type': 'Point', 'coordinates': anchor
                }
            }]
        }
    });

    map.addLayer({
        'id': 'points', 'type': 'circle', 'source': 'point',
    });
});